import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { ManualVoucherApprovalWidget } from '@/widgets/manual-voucher-approval-widget'

export const Route = createFileRoute('/_auth/applications/manual-voucher-approval/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper
      title={t(
        'Заявки для администраторов школ на подтверждение фиксации ручного учёта посещения столовой и получения питания учащихся'
      )}
    >
      <ManualVoucherApprovalWidget />
    </PageWrapper>
  )
}
